import { Container } from "@obs/components";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { UserMenu } from "../../Components/User/UserMenu";
import { Header } from "@obs/base";

export const Route = createFileRoute("/_authenticated/_agentLayout")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<Header.Web
				variant="bus"
				slotEnd={
					<>
						<UserMenu />
					</>
				}
			/>
			<Container
				maxWidth="sm"
				disableGutters
				component="main"
				sx={{
					display: "flex",
					flexDirection: "column",
					flex: 1,
				}}
			>
				<Outlet />
			</Container>
		</>
	);
}
